<template>
  <div class="primary_wrap">
    <div class="taxation_title">
      <h2>智能财税初级</h2>
    </div>
    <ul v-if="productFlag == 3" class="taxation_item">
      <li v-if="isStudent || $_has('zledu.gxzx.zhsxappcs:ctx')">
        <img src="../img/ctx-logo.png" alt="" class="app_logo"/>
        <img src="../img/ctx-bg.png" alt="" class="app_bg"/>
        <span class="text">（初级）</span>
        <el-button @click="entrySys('ctx')">进入系统</el-button>
      </li>
      <li v-if="isStudent || $_has('zledu.gxzx.zhsxappcs:ptx')">
        <img src="../img/ptx-logo.png" alt="" class="app_logo"/>
        <img src="../img/ptx-bg.png" alt="" class="app_bg"/>
        <span class="text">（初级）</span>
        <el-button @click="entrySys('ptx')">进入系统</el-button>
      </li>
      <li v-if="isStudent || $_has('zledu.gxzx.zhsxappcs:jss')">
        <img src="../img/jss-logo.png" alt="" class="app_logo"/>
        <img src="../img/jss-bg.png" alt="" class="app_bg"/>
        <span class="text">（初级）</span>
        <el-button @click="entrySys('jss')">进入系统</el-button>
      </li>
      <li v-if="isStudent || $_has('zledu.gxzx.zhsxappcs:zwfz')">
        <img src="../img/zwfz-logo.png" alt="" class="app_logo"/>
        <img src="../img/zwfz-bg.png" alt="" class="app_bg"/>
        <span class="text">（初级）</span>
        <el-button @click="entrySys('zwfz')">进入系统</el-button>
      </li>
    </ul>
    <ul v-if="productFlag == 4" class="taxation_item">
      <li v-if="isStudent || $_has('zledu.gxzx.zsrwappcs:ctx')">
        <img src="../img/ctx-logo.png" alt="" class="app_logo"/>
        <img src="../img/ctx-bg.png" alt="" class="app_bg"/>
        <span class="text">（初级）</span>
        <el-button @click="entrySys('ctx')">进入系统</el-button>
      </li>
      <li v-if="isStudent || $_has('zledu.gxzx.zsrwappcs:ptx')">
        <img src="../img/ptx-logo.png" alt="" class="app_logo"/>
        <img src="../img/ptx-bg.png" alt="" class="app_bg"/>
        <span class="text">（初级）</span>
        <el-button @click="entrySys('ptx')">进入系统</el-button>
      </li>
      <li v-if="isStudent || $_has('zledu.gxzx.zsrwappcs:jss')">
        <img src="../img/jss-logo.png" alt="" class="app_logo"/>
        <img src="../img/jss-bg.png" alt="" class="app_bg"/>
        <span class="text">（初级）</span>
        <el-button @click="entrySys('jss')">进入系统</el-button>
      </li>
      <li v-if="isStudent || $_has('zledu.gxzx.zsrwappcs:zwfz')">
        <img src="../img/zwfz-logo.png" alt="" class="app_logo"/>
        <img src="../img/zwfz-bg.png" alt="" class="app_bg"/>
        <span class="text">（初级）</span>
        <el-button @click="entrySys('zwfz')">进入系统</el-button>
      </li>
    </ul>
    <ul v-if="productFlag == 2" class="taxation_item">
      <li>
        <img src="../img/ctx-logo.png" alt="" class="app_logo"/>
        <img src="../img/ctx-bg.png" alt="" class="app_bg"/>
        <span class="text">（初级）</span>
        <el-button @click="entrySys('ctx')">进入系统</el-button>
      </li>
      <li>
        <img src="../img/ptx-logo.png" alt="" class="app_logo"/>
        <img src="../img/ptx-bg.png" alt="" class="app_bg"/>
        <span class="text">（初级）</span>
        <el-button @click="entrySys('ptx')">进入系统</el-button>
      </li>
      <li>
        <img src="../img/jss-logo.png" alt="" class="app_logo"/>
        <img src="../img/jss-bg.png" alt="" class="app_bg"/>
        <span class="text">（初级）</span>
        <el-button @click="entrySys('jss')">进入系统</el-button>
      </li>
      <li>
        <img src="../img/zwfz-logo.png" alt="" class="app_logo"/>
        <img src="../img/zwfz-bg.png" alt="" class="app_bg"/>
        <span class="text">（初级）</span>
        <el-button @click="entrySys('zwfz')">进入系统</el-button>
      </li>
    </ul>
    <el-dialog :visible.sync="centerDialogVisible" width="400px" center>
      <div class="cont">
        <p>请选择您要进入的案例公司：</p>
        <ul>
          <li
            :class="{ active: index === curId }"
            v-for="(item, index) in companyList"
            :key="index"
            @click="tabClick(item, index)"
          >
            {{ item.name }}
          </li>
        </ul>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import axios from "axios";
  import qs from "qs";
  import crypto from "crypto";
  import * as userApi from "../../../../api/userApi";

  export default {
    data() {
      return {
        sysUserPermissionList:
          JSON.parse(localStorage.getItem("sysUserPermissionList")) || [], // 权限对象
        userType: sessionStorage.getItem("userType"), //用户身份
        isStudent: false,
        productFlag: sessionStorage.getItem("productFlag"),
        centerDialogVisible: false,
        companyList: [
          {name: "北京陈鸿商贸有限责任公司", code: "003"},
          {name: "北京飞扬数码科技有限公司", code: "004"},
          {name: "北京惠龙家具商贸有限责任公司", code: "001"},
          {name: "北京子林文化有限公司", code: "002"},
          {name: "南宁泰福八宝粥有限责任公司", code: "005"},
          {name: "北京佳晟食品有限责任公司", code: "006"},
        ],
        curId: null,
        sys: "",
        deptId: sessionStorage.getItem('deptId'),
        userName: sessionStorage.getItem('userName'),
        stxUrl: process.env.STX_API,
      };
    },
    created() {
      if (this.userType == 2 || this.userType == 3) {
        this.isStudent = true;
      } else {
        this.isStudent = false;
      }
      // 临时使用，王东东  。机构为 中联学院A (deptId == 11) ，账号存在有SX2021的用户使用
      if (this.deptId == 11 && this.userName.includes('SX2021')) {
        this.stxUrl = process.env.STX_LS_API
      } else {
        this.stxUrl = process.env.STX_API
      }
    },
    methods: {
      setSha1(url) {
        //sha1加密
        const hmac = crypto.createHmac("sha1", "123456");
        hmac.update(url);
        return hmac.digest("hex");
      },
      entrySys(sys) {
        // this.courseType  1 1+X平台、2 单项训练 3综合平台
        // this.productId   1 综合 2 单项
        // this.type        1、2 单项 3 综合
        // 状态判断
        // let status = false;
        // if (sys=='zwfz' || this.userType == 0){
        //   status = true;
        // }else{
        //   if (this.sysUserPermissionList && this.sysUserPermissionList.length){
        //     [].forEach.call(this.sysUserPermissionList, item =>{
        //         if (item.productId == 1) {
        //           if (this.userType == 1){
        //             if (item.teacherOnoff == true) {
        //               status = true;
        //             }
        //           }
        //           if (this.userType == 2){
        //             if (item.studentOnoff == true) {
        //               status = true;
        //             }
        //           }
        //         }
        //     })
        //   }else{
        //     status = false;
        //   }
        // }
        // if (!status) {
        //   this.$messageWarning("没有开通权限");
        //   return false;
        // }

        if (localStorage.getItem("Authorization")) {
          let param = {
            productCode: "ctx",
            productLevel: 1,
          };
          userApi.intoSysJudge(param).then((res) => {
            if (res.code == 0) {
              this.sys = sys;
              if (
                res.data.length < this.companyList.length &&
                (sys === "ctx" || sys === "ptx" || sys === "jss")
              ) {
                this.centerDialogVisible = true;
                this.curId = null;
              } else {
                userApi
                  .isExpired(localStorage.getItem("Authorization"))
                  .then((rs) => {
                    if (rs.code == 0 && rs.data == 0) {
                      if (sys === "ctx" || sys === "ptx" || sys === "jss") {
                        this.jumpStx('001,002,003,004,005,006')
                      } else if (sys === "zwfz") {
                        let href =
                          process.env.DUMMY_API +
                          "/#/invoice?token=" +
                          localStorage.getItem("Authorization") +
                          "&questionId=999998888&courseId=99999999&classId=999998888&type=1&degree=primary&userName=" +
                          sessionStorage.getItem("loginName") +
                          "&shwoMenu=true";
                        window.open(href, "_blank");
                        this.loading = false;
                      } else {
                        this.loading = false;
                        this.$messageWarning("暂无权限，请联系管理员！");
                      }
                    } else {
                      this.$router.push({path: "/home"});
                      this.$messageError("登录已过期，请重新登录");
                      localStorage.removeItem("Authorization");
                      localStorage.removeItem("isbinding");
                    }
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              }
            }
          });
        } else {
          this.loading = false;
          this.$router.push({path: "/home"});
        }
      },
      tabClick(item, i) {
        this.curId = i;
        let param = {
          productCode: "ctx",
          productLevel: 1,
          templateCode: item.code,
        };
        userApi.selectSysJudge(param).then((res) => {
          if (res.code == 0) {
            userApi
              .isExpired(localStorage.getItem("Authorization"))
              .then((rs) => {
                if (rs.code == 0 && rs.data == 0) {
                  if (
                    this.sys === "ctx" ||
                    this.sys === "ptx" ||
                    this.sys === "jss"
                  ) {

                    this.jumpStx(item.code)

                  } else {
                    this.loading = false;
                    this.$messageWarning("暂无权限，请联系管理员！");
                  }
                } else {
                  this.$router.push({path: "/home"});
                  this.$messageError("登录已过期，请重新登录");
                  localStorage.removeItem("Authorization");
                  localStorage.removeItem("isbinding");
                }
              })
              .catch((err) => {
                console.log(err);
              });
          }
        });
      },
      jumpStx(templates){
        let userType = sessionStorage.getItem("userType");
        // let deptIdArr = ['129','134','13','516','653','648']
        // if((userType==2||userType==3) && !deptIdArr.includes(sessionStorage.getItem('deptId'))){
        //   this.$messageWarning('暂未开放')
        //   this.loading = false
        //   return
        // }
        // if((sessionStorage.getItem('auditStatus')!=2) && userType==1 ){
        //   this.$messageWarning('没有访问权限，请联系学校管理员提交账号审核。')
        //   this.loading = false
        //   return
        // }
        var tmpWin = window.open();
        tmpWin.document.open();
        tmpWin.document.write("跳转中，请稍后。。。");
        tmpWin.document.close();
        let phone = sessionStorage.getItem("mobile");
        let name = sessionStorage.getItem("loginName");
        let schoolId = sessionStorage.getItem("deptId");
        let schoolName = sessionStorage.getItem("deptName");
        let time = new Date().getTime() + "";
        let userId = sessionStorage.getItem("userId");
        let questionId = "999998888";
        let classId = "999998888";
        let courseId = "99999999";

        let url =
          "classId=" +
          classId +
          "&className=x师资培训班&courseId=" +
          courseId +
          "&mobile=" +
          phone +
          "&nickName=" +
          name +
          "&platform=" +
          this.sys +
          "&questionId=" +
          questionId +
          "&schoolId=" +
          schoolId +
          "&schoolName=" +
          schoolName +
          "&time=" +
          time +
          "&userId=" +
          userId +
          "&userType=" +
          userType;
        let sha1sign = this.setSha1(url);
        let stxObj = {
          courseId: courseId,
          classId: classId,
          className: "x师资培训班",
          mobile: phone,
          nickName: name,
          platform: this.sys,
          questionId: questionId,
          schoolId: schoolId,
          schoolName: schoolName,
          templates: templates,
          time: time,
          userId: userId,
          userType: sessionStorage.getItem("userType"),
          sign: sha1sign,
        };
        axios
          .post(this.stxUrl, qs.stringify(stxObj))
          .then((res) => {
            if (res.data.result) {
              tmpWin.location = res.data.value;
              this.loading = false;
            } else {
              this.$messageError(res.data.error.message);
              tmpWin.document.open();
              tmpWin.document.write(res.data.error.message);
              tmpWin.document.close();
              this.loading = false;
            }
          })
          .catch((err) => {
            tmpWin.document.open();
            if (err.code == "401") {
              tmpWin.document.write("登录已过期，请重新登录");
              tmpWin.location.href = process.env.BASE_API;
            } else {
              tmpWin.document.write("接口访问异常" + err.code);
            }
            tmpWin.document.close();
            this.loading = false;
          });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .primary_wrap {
    .taxation_title {
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #5397f7;

      h2 {
        border-left: 2px solid #5397f7;
        color: #5397f7;
        font-size: 14px;
        padding-left: 4px;
        line-height: 10px;
      }
    }

    .taxation_item {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 24px;

      li {
        width: 278px;
        height: 180px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.16);
        border-radius: 4px;
        position: relative;
        margin-top: 24px;
        margin-right: 40px;

        .app_logo {
          position: absolute;
          left: 40px;
          top: 48px;
          z-index: 2;
          height: 22px;
        }

        .app_bg {
          position: absolute;
          left: 0;
          top: 0;
          z-index: 1;
          width: 278px;
          height: 180px;
        }

        button {
          position: absolute;
          left: 40px;
          bottom: 24px;
          z-index: 2;
          width: 96px;
          height: 34px;
          background: rgba(255, 255, 255, 1);
          border: 1px solid rgba(83, 151, 247, 1);
          border-radius: 4px;
          padding: 0;
          color: #5397f7;

          &:hover {
            background: #5397f7;
            color: #fff;
          }
        }

        .text {
          position: absolute;
          left: 32px;
          top: 45%;
          z-index: 2;
          font-size: 16px;
          color: #004e97;
          font-weight: 600;
        }
      }
    }

    /deep/ .el-dialog__header {
      height: 48px;
      background: #edf4ff;
      padding: 20px 15px 0;
      box-sizing: border-box;
      border-radius: 8px 8px 0 0;
    }

    .cont {
      p {
        font-size: 16px;
        margin-bottom: 10px;
      }

      ul {
        width: 198px;
        margin: 0 auto;

        li {
          font-size: 14px;
          cursor: pointer;
          line-height: 24px;
          text-align: left;
        }

        li.active {
          color: #5397f7;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/views/appCenter/components/primary.vue